import styled, { css } from 'styled-components';
export const TypographyBody1 = css`
  font-size: 1rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0.00938em;
`;
const TypographyBody2 = css`
  font-size: 0.875rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.43;
  letter-spacing: 0.01071em;
`;
const TypographyButton = css`
  font-size: 0.875rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 500;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
`;
const TypographyCaption = css`
  font-size: 0.75rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.66;
  letter-spacing: 0.03333em;
`;
const TypographyH1 = css`
  font-size: 6rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 300;
  line-height: 1.167;
  letter-spacing: -0.01562em;
`;
const TypographyH2 = css`
  font-size: 3.75rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: -0.00833em;
`;
const TypographyH3 = css`
  font-size: 3rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.167;
  letter-spacing: 0em;
`;
const TypographyH4 = css`
  font-size: 2.125rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.235;
  letter-spacing: 0.00735em;
`;
const TypographyH5 = css`
  font-size: 1.5rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.334;
  letter-spacing: 0em;
`;
const TypographyH6 = css`
  font-size: 1.25rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: 0.0075em;
`;
const TypographyOverline = css`
  font-size: 0.75rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 2.66;
  letter-spacing: 0.08333em;
  text-transform: uppercase;
`;
const TypographySubtitle1 = css`
  font-size: 1rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 400;
  line-height: 1.75;
  letter-spacing: 0.00938em;
`;
const TypographySubtitle2 = css`
  font-size: 0.875rem;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 500;
  line-height: 1.57;
  letter-spacing: 0.00714em;
`;
export const TypographyWrapper = styled.p`
  ${props => {
  switch (props.align) {
    case 'center':
      return 'text-align: center';

    case 'justify':
      return 'text-align: justify';

    case 'left':
      return 'text-align: left';

    case 'right':
      return 'text-align: right';

    case 'inherit':
      return '';
  }
}};
  color: ${props => {
  switch (props.color) {
    case 'primary':
      return '#3f51b5';

    case 'secondary':
      return '#f50057';

    case 'textSecondary':
      return 'rgba(0, 0, 0, 0.54)';

    case 'error':
      return '#f44336';

    case 'inherit':
      return 'inherit';

    case 'initial':
      return 'initial';

    case 'textPrimary':
      return 'rgba(0, 0, 0, 0.87)';

    default:
      return '';
  }
}};
  ${props => {
  switch (props.variant) {
    case 'body1':
      return TypographyBody1;

    case 'body2':
      return TypographyBody2;

    case 'button':
      return TypographyButton;

    case 'caption':
      return TypographyCaption;

    case 'h1':
      return TypographyH1;

    case 'h2':
      return TypographyH2;

    case 'h3':
      return TypographyH3;

    case 'h4':
      return TypographyH4;

    case 'h5':
      return TypographyH5;

    case 'h6':
      return TypographyH6;

    case 'inherit':
      return '';

    case 'overline':
      return TypographyOverline;

    case 'subtitle1':
      return TypographySubtitle1;

    case 'subtitle2':
      return TypographySubtitle2;
  }
}};
  ${props => props.noWrap ? `overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;` : ''};
  margin: 0;
`;